import { httpClient } from '@/lib/http-client'
import type {
  Response,
  EpisodePicListResponse,
  ProjectListResponse,
  ProjectListParams,
  ProjectEpisodeListResponse,
  ProjectVideoSetListResponse,
  VideoSetContentsParams,
  VideoSetContentsResponse,
  AddVideoSetResponse,
  SaveVideoSetParams,
  CreateVideoParams,
  EpisodeVideoAuditListResponse,
  CharacterListResponse,
  CharacterDetailResponse,
  EnhanceVideoPromptParams,
  VideoClipParams,
  VideoCombineParams,
  VideoCombineQueryData,
} from './type'

// 获取项目列表
export const apiGetProjectList = (data: ProjectListParams) =>
  httpClient.post<Response<ProjectListResponse>>('/motioncomic/project_list', data)

// 项目剧集列表
export const apiGetProjectEpisodeList = (data: { project_id: number }) =>
  httpClient.post<Response<ProjectEpisodeListResponse>>('/motioncomic/project_episode_list', data)

// 获取分镜图列表
export const apiGetEpisodePicListApi = (data: { project_id: number, episode_id: number }) =>
  httpClient.post<Response<EpisodePicListResponse>>('/motioncomic/episode_pic_set_list', data)

// 项目视频集列表
export const apiGetEpisodeVideoSetList = (data: { project_id: number, episode_id: number }) =>
  httpClient.post<Response<ProjectVideoSetListResponse>>('/motioncomic/episode_video_set_list', data)

// 视频集的视频列表
export const apiGetVideoSetContents = (data: VideoSetContentsParams) =>
  httpClient.post<Response<VideoSetContentsResponse>>('/motioncomic/video_set_contents', data)

// 视频集添加
export const apiAddVideoSet = (data: { project_id: number, episode_id: number, episode_num: number, count: number }) =>
  httpClient.post<Response<AddVideoSetResponse>>('/motioncomic/video_set_add', data)

// 视频集保存
export const apiSaveVideoSet = (data: SaveVideoSetParams) =>
  httpClient.post<Response<{ success: boolean }>>('/motioncomic/video_set_save', data)

// 视频生成
export const apiCreateVideo = (data: CreateVideoParams) =>
  httpClient.post<Response<{ success: boolean, task_id: string }>>('/motioncomic/video_create', data)

// 视频收藏/取消收藏
export const apiBookmarkVideo = (data: { video_id: number, bookmark: 0 | 1 }) =>
  httpClient.post<Response<{ success: boolean }>>('/motioncomic/video_bookmark', data)

// 视频提交审核
export const apiCommitVideoAudit = (data: { video_id: number }) =>
  httpClient.post<Response<{ success: boolean }>>('/motioncomic/video_audit_commit', data)

// 视频审核列表
export const apiGetEpisodeVideoAuditList = (data: { project_id: number, episode_id: number }) =>
  httpClient.post<Response<EpisodeVideoAuditListResponse>>('/motioncomic/episode_video_audit_list', data)

// 图生视频提示词优化
export const apiEnhanceVideoPrompt = (data: EnhanceVideoPromptParams) =>
  httpClient.post<Response<{ enhanced_prompt: string }>>('/motioncomic/video_prompt_enhance', data)

// 视频上传
export const apiUploadVideo = (data: { project_id: number, episode_id: number, episode_num: number, serial_number: number, video_path: string }) =>
  httpClient.post<Response<{ success: boolean, batch_id: string, task_id: string }>>('/motioncomic/video_upload', data)

// 人设列表
export const apiGetCharacterList = (data: {
  list_type: 1 | 2,
  project_id: number,
  name: string,
  page_index: number,
  page_size: number
}) =>
  httpClient.post<Response<CharacterListResponse>>('/motioncomic/three_view_role_list', data)

// 人设详情
export const apiGetCharacterDetail = (data: {
  role_id: number
}) =>
  httpClient.post<Response<CharacterDetailResponse>>('/motioncomic/three_view_role_info', data)

// 视频裁剪
export const apiVideoClip = (data: VideoClipParams) =>
  httpClient.post<Response<{ success: boolean }>>('/motioncomic/video_clip', data)

// 视频合成
export const apiVideoCombine = (data: VideoCombineParams) =>
  httpClient.post<Response<{ success: boolean }>>('/motioncomic/video_combine', data)

// 视频合成状态查询
export const apiVideoCombineQuery = (data: VideoCombineParams) =>
  httpClient.post<Response<VideoCombineQueryData>>('/motioncomic/video_combine_query', data)
